import { render } from "./App.vue?vue&type=template&id=2489d3fb&scoped=true&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=2489d3fb&lang=css"
import "./App.vue?vue&type=style&index=1&id=2489d3fb&lang=scss&scoped=true"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2489d3fb"]])

export default __exports__